<template>
  <div class="term-page">
    <el-card class="box-card"> 
      <!-- 搜索区域 -->
      <el-form
        ref="queryRef"
        :model="queryParams"
        :inline="true"
      >
      <div slot="header" class="clearfix">
        <span>术语信息</span>
      </div>
        <el-form-item label="关键字" prop="key">
          <el-input
            v-model="queryParams.key"
            placeholder="请输入关键字"
            clearable
            @keyup.enter="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">搜索</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 操作按钮区 -->
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
            type="primary"
            plain
            @click="handleAdd">
            新增术语
          </el-button>
        </el-col>
      </el-row>

      <!-- 数据表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        @selection-change="handleSelectionChange"
        height="400px"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="中文名称" prop="cName" align="center" />
        <el-table-column label="英文名称" prop="eName" align="center" />
        <!-- 修改图片列 -->
<el-table-column label="图片" prop="imageList" align="center">
  <template #default="scope">
    <div class="image-previews">
      <!-- 优先使用imageList -->
      <template v-if="scope.row.imageList?.length">
        <el-image
          style="width: 50px; height: 50px; margin-right: 5px;"
          :src="scope.row.imageList[0]"
          :preview-src-list="scope.row.imageList"
          fit="cover"
        >
          <template #error>
            <div class="image-slot">
              <el-icon><Picture /></el-icon>
            </div>
          </template>
        </el-image>
      </template>
      
      <!-- 兼容旧image字段 -->
      <template v-else-if="scope.row.image">
        <el-image
          style="width: 50px; height: 50px"
          :src="scope.row.image"
          :preview-src-list="[scope.row.image]"
          fit="cover"
        >
          <template #error>
            <div class="image-slot">
              <el-icon><Picture /></el-icon>
            </div>
          </template>
        </el-image>
      </template>
      
      <span v-else>暂无图片</span>
    </div>
  </template>
</el-table-column>
        <el-table-column label="解释" prop="explanation" align="center" />

        <el-table-column label="操作" align="center" width="200">
          <template #default="scope">
            <el-button link type="primary" :icon="Edit"  @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button link type="danger" :icon="Delete" @click="handleDelete(scope.row)">
              删除
            </el-button>
            <el-button link type="primary" :icon="View" @click="handleView(scope.row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-model:current-page="queryParams.pageNum"
        v-model:page-size="queryParams.pageSize"
        :total="total"
        :page-sizes="[10,20, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

      <!-- 编辑对话框 -->
      <el-dialog v-model="dialogVisible" title="新增术语"width="500px":close-on-click-modal="false">
        <el-form 
          :model="formData"
          label-width="100px"
          v-loading="loading"
        >
          <el-form-item label="中文名称" required>
            <el-input 
              v-model="formData.cName"
              placeholder="请输入术语中文名称"
            />
          </el-form-item>
          <el-form-item label="英文名称">
            <el-input 
              v-model="formData.eName"
              placeholder="请输入术语英文名称"
            />
          </el-form-item>
          <el-form-item label="解释说明">
            <el-input 
              v-model="formData.explanation"
              type="textarea"
              rows="3"
              placeholder="请输入术语解释说明"
            />
          </el-form-item>
            <el-form-item label="图片">
        <MultipleUploadComponent
          ref="multiUploadRef"
          v-model="formData.imageList"
          @change="handleImagesChange"
        />
      </el-form-item>
        
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary"  @click="handleConfirm" :loading="loading">
              确定
            </el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 查看抽屉 -->
      <el-drawer
        v-model="drawer"
        title="查看术语详情"
        direction="rtl"
        size="500px"
      >
        <el-descriptions :column="1" border>
          <el-descriptions-item label="所属标准">
            {{ viewData.standardName }}
          </el-descriptions-item>
          <el-descriptions-item label="中文名称">
            {{ viewData.cName }}
          </el-descriptions-item>
          <el-descriptions-item label="英文名称">
            {{ viewData.eName }}
          </el-descriptions-item>
            <el-descriptions-item label="图片">
        <div class="image-previews" v-if="viewData.imageList?.length">
          <el-image
            v-for="(url, index) in viewData.imageList"
            :key="index"
            style="width: 100px; height: 100px; margin-right: 10px;"
            :src="url"
            :preview-src-list="viewData.imageList"
            fit="cover"
          />
        </div>
        <span v-else>暂无图片</span>
      </el-descriptions-item>
        </el-descriptions>
      </el-drawer>
    </el-card>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, watch, computed } from 'vue'
import { ElMessage, ElMessageBox, imageEmits } from 'element-plus'
import { Search, Refresh, Plus, Edit, Delete, View, Picture } from '@element-plus/icons-vue'
import type { FormInstance } from 'element-plus'
import {  addTerm } from '../api/menu'
import { listTermByPage,deleteTerm,updateTerm} from '@/api/term'
import MultipleUploadComponent from "@/components/MultipleUploadComponent.vue"


const props = defineProps<{
  termsData: {
    id?: string | number;
    standardId?: string | number;
    cName?: string;
    eName?: string;
    explanation?: string;
    image?: string;
    imageList: []
 }[];
  standardId?: string | number;
  loading?: boolean;
}>()
const emit = defineEmits(['update', 'save', 'menu-action'])
const uploadComponentRef = ref()
// 添加处理多图上传变化的方法
const handleImagesChange = (urls: string[]) => {
  formData.value.imageList = urls
  // 保持单图兼容性
  formData.value.image = urls.length > 0 ? urls[0] : ""
}

// 表格数据
const loading = ref(false)
const tableData = ref<any[]>([])
const total = ref(0)
const ids = ref<string[]>([])

// 查询参数
const queryParams = reactive({
  standardId: '',
  pageNum: 1,
  pageSize: 10,
  key: ''
})

// 表单实例
const queryRef = ref<FormInstance>()
// 对话框和抽屉控制
const dialogVisible = ref(false)
const drawer = ref(false)
const editingTerm = ref<any>(null)

// 查看数据
const viewData = ref({
  standardName: '',
  cName: '',
  eName: '',
  explanation: '',
  image:'',
  imageList: [] as string[]
})

// 处理查询
const handleQuery = () => {
  queryParams.pageNum = 1
  getList()
}

// 重置查询
const resetQuery = () => {
  queryRef.value?.resetFields()
  queryParams.pageNum = 1
  queryParams.pageSize = 10
  getList()
}

// 处理选择变化
const handleSelectionChange = (selection: any[]) => {
  ids.value = selection.map(item => item.id)
}

// 处理分页
const handleSizeChange = (val: number) => {
  queryParams.pageSize = val
  getList()
}

const handleCurrentChange = (val: number) => {
  queryParams.pageNum = val
  getList()
}

// 新增术语
// 添加 upload 组件的引用
function handleAdd() {
  editingTerm.value = null
  // Clear the data
  formData.value = {
    id:   '',
    standardId: props.termsData[0]?.id || '', // 从 props 获取 standardId
    cName: '',
    eName: '',
    explanation: '',
    image: '',
    imageList: [] as string[]
  }
  // 清除上传组件的图片
  uploadComponentRef.value?.clearFiles()
  dialogVisible.value = true
}
// 编辑术语
const handleEdit = (row: any) => {
  editingTerm.value = row
  formData.value = { ...row }
  dialogVisible.value = true
}

// 查看术语
const handleView = (row: any) => {
  viewData.value = {
    ...row,
    imageList: row.imageList || 
      (row.image ? row.image.split(',').filter((url: string) => url.trim()) : [])
  }
    drawer.value = true
}


// 数据操作区--> 删除按钮
function handleDelete(row: any) {
  const id = row.id
  ElMessageBox.confirm(
    `是否确认删除编号为"${id}"的标准?`,
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  .then(async () => {
    try {
      const response = await deleteTerm(id)
      if (response?.code === 1) {
        ElMessage.success('删除成功')
        getList() // 刷新列表
        emit('update'); // 通知父组件刷新
      } else {
        ElMessage.error(response?.msg || '删除失败')
      }
    } catch (error) {
      console.error('删除失败:', error)
      ElMessage.error('删除失败，请重试')
    }
  })
  .catch(() => {
    ElMessage.info('已取消删除')
  })
}

// 获取数据列表
function getList() {
  loading.value = true
  try {
    // 如果有 standardId，则从服务器获取数据
    if (queryParams.standardId) {
      listTermByPage({
        page: queryParams.pageNum,
        pageSize: queryParams.pageSize,
        standardId: String(queryParams.standardId), // Convert to string
        key: queryParams.key
      }).then(response => {
        if (response && response.data) {
          tableData.value = response.data.records || []
          total.value = response.data.total || 0
        
        }
      })
    } else {
      // 否则使用 props 传入的数据
      tableData.value = props.termsData
      total.value = props.termsData.length
    }
  } catch (error) {
    console.error('获取数据失败:', error)
    ElMessage.error('获取数据失败')
  } finally {
    loading.value = false
  }
}
// 监听数据变化
watch(() => props.termsData, (newVal) => {
  if (newVal) {
    tableData.value = newVal.map(item => ({
      ...item,
      // 处理旧数据兼容（将image字段转为imageList）
      imageList: item.image 
        ? item.image.split(',').filter(url => url.trim())
        : item.imageList || []
    }))
    total.value = newVal.length
  }
}, { immediate: true, deep: true })

const formData = ref({
  id: '',
  cName: '',
  eName: '',
  explanation: '',
  image: '',
  imageList: [] as string[],
  standardId: props.standardId || '' // 使用传入的 standardId
})

const handleConfirm = async () => {
  if (!formData.value.cName) {
    ElMessage.warning('请输入中文名称');
    return;
  }
  // 修改标准ID的验证
  if (!props.standardId) {
    ElMessage.warning('缺少标准ID');
    return;
  }
  try {
    loading.value = true; 
    // 准备发送的数据
    const submitData = {
      id: formData.value.id || undefined,
      standardId: Number(props.standardId), // 使用传入的 standardId
      cName: formData.value.cName,
      eName: formData.value.eName || '',
      explanation: formData.value.explanation || '',
      imageList: formData.value.imageList || []
    };
    let response;
    if (editingTerm.value) {
      // 编辑模式：调用 updateTerm
      response = await updateTerm(submitData);
    } else {
      // 新增模式：调用 addTerm
      response = await addTerm(submitData);
    }
    if (response?.code === 1) {
      ElMessage.success(editingTerm.value ? '更新术语成功' : '新增术语成功');
      // dialogVisible.value = false;
      resetForm();
      uploadComponentRef.value?.clearFiles();
      await getList();
      emit('update'); // 触发父组件更新

    } else {
      ElMessage.error(response?.msg || (editingTerm.value ? '更新术语失败' : '新增术语失败'));
    }
  } catch (error) {
    console.error(editingTerm.value ? '更新术语失败:' : '新增术语失败:', error);
    ElMessage.error(editingTerm.value ? '更新术语失败' : '新增术语失败');
  } finally {
    loading.value = false;
  }
};
const resetForm = () => {
  formData.value = {
    id: '',
    cName: '',
    eName: '',
    explanation: '',
    image: '',
    standardId: props.termsData[0]?.id || '',
    imageList: []
  }
}
// Add type declaration for window
declare const window: Window & typeof globalThis;
</script>

<style scoped>
.term-page {
  padding: 20px;
}

.el-table .cell {
  /* 确保文本不换行 */
  white-space: nowrap;
  /* 隐藏溢出文本 */
  overflow: hidden;
  /* 使用省略号表示溢出文本 */
  text-overflow: ellipsis;
  /* 新增以下内容 */
  max-width: 200px;  /* 根据列宽调整 */
  display: block;    /* 确保溢出生效 */
  line-height: 24px; /* 保持行高一致 */
}

.mb8 {
  margin-bottom: 8px;
}

.dialog-footer {
  text-align: right;
}

.image-preview {
  margin-top: 10px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}
/* 强制所有行高度固定 */
:deep(.el-table__body tr) {
  height: 50px !important; /* 统一行高 */
}
/* 单元格内容垂直居中 */
:deep(.el-table__cell) {
  
  line-height: 1.5 !important; /* 控制文本行高 */
}

</style>












